module.exports = __webpack_public_path__ + "static/media/user-black.8e2d2b6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/assets/images/user-black.png
// module id = 967
// module chunks = 0